<template>
  <div>
    <div v-if="showPallets">
      <v-toolbar flat color="white">
        <v-toolbar-title class="table_title">
          {{
          $t("pallets_crud.pallets")
          }}
        </v-toolbar-title>
        <v-divider inset vertical></v-divider>
        <v-flex xs12 md4>
          <v-text-field
            append-icon="search"
            single-line
            hide-details
            clearable
            v-model="filter"
            autofocus
            :label="$t('pallets_crud.filter')"
            @input="isChangingFilter = true"
          ></v-text-field>
        </v-flex>
        <v-flex xs24 md8>
          <!-- status selector -->
          <status-selector
            :from="statusFrom"
            :to="statusTo"
            :table="'pallets'"
            :language="this.$router.currentRoute.params.lang.toUpperCase()"
            @statusesChanged="changeStatusFilters"
          />
        </v-flex>
        <v-flex xs6 sm2 d-flex>
          <v-select
            v-model="perPage"
            @input="changePage"
            single-line
            hide-details
            prepend-icon="pages"
            :items="perPageSelection"
            :label="$t('pallets_crud.per_page')"
          ></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-dialog v-if="user.type != 6" v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">
              {{
              $t("pallets_crud.new_pallet")
              }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex>
                    <v-textarea v-model="editedItem.comment" :label="$t('pallets_crud.remarks')"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">
                {{
                $t("pallets_crud.cancel")
                }}
              </v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="save"
                v-if="editedIndex === -1"
              >{{ $t("pallets_crud.save") }}</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="edit"
                v-if="editedIndex != -1"
              >{{ $t("pallets_crud.edit") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- export selected pallets pdf -->
        <v-btn
          color="primary"
          :disabled="selected.length == 0"
          @click="preperationPdf"
        >{{ $t("general_controls.pallets_prepare_pdf") }}</v-btn>
        <v-btn
          color="primary"
          :disabled="selected.length == 0"
          @click="barcodesPdf"
        >{{ $t("general_controls.barcodes_pdf") }}</v-btn>
        <v-btn
          color="primary"
          :disabled="loadingDisabled"
          @click="loadingPdf"
        >{{ $t("general_controls.loading_pdf") }}</v-btn>
        <v-btn
          v-if="user.type < 4"
          color="primary"
          :disabled="selected.length == 0"
          @click="opticutExport"
        >{{ $t("opticut_export.export") }}</v-btn>
        <v-btn color="primary" :disabled="selected.length == 0" @click="openPalletingPage">
          <v-icon>local_shipping</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="table-wrapper">
        <div class="progress-wrapper">
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
        </div>
        <div class="rTable">
          <div class="rTableRow problem-header">
            <div class="rTableHead" :style="{ 'width': 2 + '%'}">
              <input id="pallets-checkbox" type="checkbox" @click="selectAllPallets($event)" />
            </div>
            <div
              class="rTableHead"
              v-for="(header, i) in headers"
              :key="i"
              :style="{ 'width': header.width + '%'}"
            >{{header.text}}</div>
          </div>
          <div class="rTableRow" v-for="(pallet, i ) in pallets" :key="i">
            <div class="rTableCell">
              <input class="pallet-checkbox" type="checkbox" @click="selectPallet($event, pallet)" />
            </div>
            <div class="rTableCell clickable" @click="openPalletInfo(pallet.id)">
              <span class="pallet-year">{{pallet.getYear()}}</span>
              {{ pallet.getNumber() }}
            </div>
            <div class="rTableCell">{{ pallet.customer_name }}</div>
            <div class="rTableCell">
              <a
                v-for="(order, index) in getOrderNames(pallet.order_number)"
                :key="index"
                @click="openOrder(pallet, order)"
              >
                <span
                  class="order-number"
                  v-if="
                    getOrderNames(pallet.order_number).length != 1 &&
                      index != getOrderNames(pallet.order_number).length - 1
                  "
                >{{ order }}</span>
                <span class="order-number" v-else>{{ order }}</span>
              </a>
            </div>
            <div class="rTableCell">
              <a>{{ dispatchName(pallet) }}</a>
            </div>
            <div class="rTableCell">{{ pallet.length }} x {{ pallet.width }}</div>
            <div class="rTableCell number-cell">{{ pallet.products_count }}</div>
            <div class="rTableCell pallet-comment">{{ pallet.comment }}</div>
            <div class="rTableCell">
              <change-status-to
                @statusChanged="initialize"
                :id="pallet.id"
                :statusNames="statusNames"
                :statusRights="statusRights"
                :user="user"
                :currentStatus="pallet.status"
                :table="'pallets'"
              />
            </div>
            <div class="rTableCell">
              <v-icon
                v-tooltip="$t('pallets_crud.view_packing')"
                small
                class="mr-2"
                @click="viewOrder(pallet)"
              >local_shipping</v-icon>
              <v-icon
                v-tooltip="$t('pallets_crud.view_pallet')"
                small
                class="mr-2"
                @click="viewPallet(pallet)"
              >image</v-icon>
              <status-changes
                :item="pallet"
                :table="'pallet'"
                class="mr-2"
                v-tooltip="$t('pallets_crud.view_changes')"
              ></status-changes>
              <v-icon
                v-if="user.type != 6"
                small
                class="mr-2"
                v-tooltip="$t('pallets_crud.pallet_edit')"
                @click="editItem(pallet)"
              >edit</v-icon>
              <v-icon
                v-if="user.type != 6"
                small
                class="mr-2"
                v-tooltip="$t('pallets_crud.delete_pallet')"
                @click="deleteItem(pallet)"
              >delete</v-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="text-xs-center">
        <v-pagination v-model="page" :length="pagesCount"></v-pagination>
      </div>
    </div>
    <pallet-quick-view ref="quickView" />
  </div>
</template>

<script>
import Pallet from "@/models/Pallet.js";
import StatusChanges from "@/components/status-changes/StatusChanges.vue";
import ChangeStatusTo from "@/components/status-changes/StatusChangeTo.vue";
import StatusSelector from "@/components/status-changes/StatusSelector.vue";
import Export from "@/models/Export.js";
import HttpClient from "@/models/HttpClient.js";
import PalletQuickView from "./PalletQuickViewDialog.vue";
import Helper from "@/models/Helper.js";

export default {
  props: ["user", "selectable", "statusToProp", "changeableStatus"],
  data() {
    return {
      isChangingFilter: false,
      filterTimer: 0,
      selected: [],
      async: false,
      dialog: false,
      showPallets: false,
      loading: false,
      pallets: [],
      filter:
        this.$route.params.filter != "null" ? this.$route.params.filter : "",
      statusNames: this.$session.get("statusNames").filter((e) => {
        return e.table_name == "pallets";
      }),
      statusRights: this.$session.get("statusRights"),
      statusFrom: this.getStatusFromFromRoute(this.$route.params.status_from),
      statusTo: this.getStatusToFromRoute(this.$route.params.status_to),
      headers: [
        {
          text: this.$t("pallets_crud.number"),
          align: "left",
          value: "number",
          sortable: false,
          width: 5,
        },
        {
          text: this.$t("pallets_crud.customer"),
          value: "customer_name",
          sortable: false,
          width: 18,
        },
        {
          text: this.$t("pallets_crud.order"),
          value: "order_number",
          sortable: false,
          width: 15,
        },
        {
          text: this.$t("pallets_crud.delivery"),
          value: "truck_id",
          sortable: false,
          width: 5,
        },
        {
          text: this.$t("pallets_crud.dimensions"),
          value: "length",
          sortable: false,
          width: 5,
        },
        {
          text: this.$t("pallets_crud.products_count"),
          value: "length",
          sortable: false,
          width: 5,
        },
        {
          text: this.$t("pallets_crud.comment"),
          value: "length",
          sortable: false,
          width: 25,
        },
        {
          text: this.$t("pallets_crud.status"),
          value: "status",
          sortable: false,
          width: 10,
        },
        {
          text: this.$t("pallets_crud.actions"),
          value: "actions",
          sortable: false,
          width: 10,
        },
      ],
      perPage: localStorage.getItem("pallets-per-page") != null ? parseInt(localStorage.getItem("pallets-per-page")) : 30,
      perPageSelection: [20, 30, 50, 100],
      pagination: {
        descending: true,
        page: 1,
        sortBy: "number",
        totalItems: 0,
      },
      page: this.$route.params.page ? parseInt(this.$route.params.page) : 1,
      pagesCount: 1,
      editedIndex: -1,
      editedItem: {
        length: 0,
        width: 0,
        pallet_height: 0,
        comment: "",
      },
      defaultItem: {
        length: 0,
        width: 0,
        pallet_height: 0,
        comment: "",
      },
    };
  },

  components: {
    ChangeStatusTo,
    StatusSelector,
    PalletQuickView,
    StatusChanges,
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("pallets_crud.new_pallet")
        : this.$t("pallets_crud.edit_pallet");
    },
    selectAllAvailable() {
      if (this.changeableStatus) {
        return true;
      }
      return this.selectable && this.pagesCount == 1;
    },
    loadingDisabled() {
      if (this.selected.length == 0) return true;
      const count = this.selected.filter((pallet) => {
        return pallet.number != null;
      }).length;
      return count != this.selected.length;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    page() {
      this.redirect();
      this.initialize();
    },
    pagination: {
      handler() {
        this.redirect();
        this.initialize();
      },
      deep: true,
    },
    selected() {
      this.$emit("selectedPallets", this.selected);
    },

    isChangingFilter(val) {
      if (!val) {
        this.initialize();
      }
    },

    filter() {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
      if (this.filter == "") {
        this.filter = null;
      }
      this.redirect();
    },

    statusFrom() {
      this.redirect();
      this.initialize();
    },

    statusTo() {
      this.redirect();
      this.initialize();
    },

    pagesCount() {
      if (!this.selectAllAvailable) {
        this.headers.unshift({
          text: "",
          value: "selectable",
          sortable: false,
        });
      } else {
        if (!this.changeableStatus) {
          this.headers.splice(0, 1);
        }
      }
    },
  },

  mounted() {
    if (!this.changeableStatus) {
      this.headers.splice(7, 1);
    }
    this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;
      const { pallets, lastPage } = await Pallet.loadPallets(
        this.getSearchParams()
      );
      this.pallets = pallets;
      this.pagesCount = lastPage;
      this.loading = false;
      this.showPallets = true;
      await Helper.timeout(50);
      this.clearSelected();
    },

    changePage(){
      localStorage.setItem('pallets-per-page', this.perPage);
      this.initialize();
    },

    clearSelected() {
      this.selected = [];
      const mainCheckbox = document.getElementById("pallets-checkbox");
      const checkboxes = document.getElementsByClassName("pallet-checkbox");
      mainCheckbox.checked = false;
      for (const checkbox of checkboxes) {
        checkbox.checked = false;
      }
    },

    selectAllPallets(event) {
      const checkboxes = document.getElementsByClassName("pallet-checkbox");
      for (const pallet of this.pallets) {
        this.selectPallet(event, pallet);
      }
      for (const checkbox of checkboxes) {
        checkbox.checked = event.target.checked;
      }
    },

    selectPallet(event, pallet) {
      if (event.target.checked) {
        this.addSelected(pallet);
      } else {
        this.removeSelected(pallet);
      }
    },

    addSelected(newPallet) {
      const found = this.selected.find((pallet) => {
        return pallet.id === newPallet.id;
      });
      if (!found) {
        this.selected.push(newPallet);
      }
    },

    removeSelected(newPallet) {
      const palletIndex = this.selected.indexOf(newPallet);
      if (palletIndex != -1) {
        this.selected.splice(palletIndex, 1);
      }
    },

    openPalletingPage() {
      let orderFilter = "";
      const selectedOrders = [];
      this.selected.forEach((pallet) => {
        const orders = pallet.order_number.split(",");
        orders.forEach((order) => {
          if (!selectedOrders.includes(order.trim())) {
            selectedOrders.push(order.trim());
          }
        });
      });
      selectedOrders.forEach((order, i) => {
        orderFilter += order;
        if (selectedOrders.length > 1 && selectedOrders.length - 1 != i) {
          orderFilter += ", ";
        }
      });
      this.$router.push({
        name: "pallet-planning",
        params: { filter: orderFilter },
      });
    },

    /**
     * gets status from rom router link
     * @param statusFrom
     */
    getStatusFromFromRoute(statusFrom) {
      if (statusFrom == null) {
        return 0;
      }
      return parseInt(statusFrom);
    },

    /**
     * gets status to from router link
     * @param statusTo
     */
    getStatusToFromRoute(statusTo) {
      if (!this.changeableStatus) {
        return 2;
      }
      if (statusTo == null) {
        return 100;
      }
      return parseInt(statusTo);
    },

    /**
     * returns dispatch name for pallet
     * @param pallet
     */
    dispatchName(pallet) {
      if (pallet.truck_status >= 1) {
        return pallet.description;
      }
      return "";
    },

    /**
     * gets seperate order names from order string
     */
    getOrderNames(orderString) {
      if (orderString == null) {
        return [];
      }
      const orderNames = orderString.split(",");
      return orderNames;
    },

    /**
     * opens order page with products
     */
    async openOrder(pallet, orderCode) {
      let order = null;
      pallet = await Pallet.loadPallet(pallet.id, {
        with_products: 1,
        with_order: 1,
      });
      pallet.products.forEach((product) => {
        if (product.order.toString() == orderCode.trim()) {
          order = product.order;
        }
      });
      if (order) {
        this.$router
          .push({
            path: `/${this.$router.currentRoute.params.lang}/products/${order.id}`,
          })
          .catch(() => {});
      }
    },

    statusToValue() {
      if (this.statusToProp != null) {
        return this.statusToProp;
      }
      return this.$route.params.status_to != null
        ? parseInt(this.$route.params.status_to)
        : 100;
    },

    changeStatusFilters(statuses) {
      this.statusFrom = statuses.status_from != null ? statuses.status_from : 0;
      this.statusTo = statuses.status_to != null ? statuses.status_to : 100;
    },

    isOnTruck(pallet) {
      if (pallet.truck_status < 1) {
        return false;
      }
      if (pallet.truck_id != null) {
        return true;
      }
      return false;
    },

    editItem(pallet) {
      this.editedIndex = this.pallets.indexOf(pallet);
      this.editedItem = Object.assign({}, pallet);
      this.dialog = true;
    },

    async deleteItem(pallet) {
      if (!this.user.hasRights("TP_EDIT")) {
        alert(this.$t("pallets_crud.no_rights_to_delete_pallet"));
        return 0;
      }
      confirm(this.$t("pallets_crud.delete_pallet_confirm")) &&
        (await pallet.remove());
      this.initialize();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      await Pallet.createPallet({
        length: parseInt(this.editedItem.length),
        width: parseInt(this.editedItem.width),
        height: parseInt(this.editedItem.pallet_height),
        pallet_height: parseInt(this.editedItem.pallet_height),
      });
      this.initialize();
      this.dialog = false;
    },

    async edit() {
      const pallet = new Pallet(this.editedItem);
      await pallet.save();
      this.initialize();
      this.dialog = false;
    },

    reset() {
      this.$router
        .push({
          path: `/${this.$router.currentRoute.params.lang}/pallets`,
        })
        .catch(() => {});
      this.$router.go();
    },

    getSearchParams() {
      let params = {};
      if (this.filter != "" && this.filter != null) {
        params["filter"] = this.filter;
      }
      if (this.statusFrom != null) {
        params["status_from"] = this.statusFrom;
      }
      if (this.statusTo != null) {
        params["status_to"] = this.statusTo;
      }
      if (this.perPage != null) {
        params["rows"] = this.perPage;
      }
      params["page"] = this.page;
      return params;
    },

    /**
     * shows truck
     * @param pallet
     */
    viewTruck(pallet, allow) {
      const link =
        this.user.hasRights("TP_EDIT") && pallet.status == 0
          ? "truck"
          : "truck-viewing";
      if ((pallet.truck_id != null && pallet.truck_status >= 1) || allow) {
        this.$router
          .push({
            path: `/${this.$router.currentRoute.params.lang}/${link}/${pallet.truck_id}/-1/${pallet.id}`,
          })
          .catch(() => {});
      }
    },

    async viewOrder(pallet) {
      if (pallet.order_number == "") {
        return;
      }
      this.$router.push({
        name: "pallet-planning",
        params: { filter: pallet.order_number },
      });
    },

    openPalletInfo(palletId) {
      this.$router.push({
        name: "pallet-info",
        params: { id: palletId },
      });
    },

    /**
     * shows pallet
     * @param pallet
     */
    viewPallet(pallet) {
      this.$refs.quickView.$data.palletId = pallet.id;
    },

    /**
     * changes router link
     */
    redirect() {
      if (this.changeableStatus) {
        const filter =
          this.filter != null && this.filter.length > 0 ? this.filter : null;
        const page = this.page != null ? this.page : null;
        const orderBy =
          this.pagination.sortBy == null ? "null" : this.pagination.sortBy;
        const order =
          this.pagination.descending == null
            ? "null"
            : this.pagination.descending;
        this.$router
          .replace({
            path: `/${this.$router.currentRoute.params.lang}/pallets/${filter}/${this.statusFrom}/${this.statusTo}/${page}/${orderBy}/${order}`,
          })
          .catch(() => {});
      }
    },

    preperationPdf() {
      if (
        this.selected.filter((pallet) => {
          return pallet.status >= 1;
        }).length != this.selected.length
      ) {
        if (this.user.type == 6) {
          alert(this.$t("pallets_crud.chosen_pallets_not_prepared"));
          return;
        }
        const confirmed = confirm(
          this.$t("truck_pallets_export.confirm_download")
        );
        if (!confirmed) return;
      }
      const downloader = new Export(this.selected, [], new HttpClient());
      downloader.palletsPreparationExport(this);
    },

    barcodesPdf() {
      const downloader = new Export(this.selected, [], new HttpClient());
      downloader.barcodesExport(this);
    },

    loadingPdf() {
      const downloader = new Export(this.selected, [], new HttpClient());
      downloader.loadingExport(this);
    },

    opticutExport() {
      const downloader = new Export(this.selected, [], new HttpClient());
      downloader.opticutFileExport(this);
    },
  },
};
</script>

<style scoped>
.table_title {
  width: 10%;
}
.pallet-comment {
  width: 20%;
}
.on_truck {
  background-color: rgba(240, 58, 13, 0.185);
}
.order-number:hover {
  color: rgb(25, 118, 210);
}
.icons {
  width: 150px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 10px;
}
.pallet-year {
  color: grey;
}
</style>